/**
 * @author Lucas Fridez <lfridez@artionet.com>
 * @client Inelectro
 * @project webapp-scan
 * @file src\app\UI\components\templates\EmptyMessage.jsx
 * @copyright 2018 Artionet Web Agency
 */

import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export const EmptyMessage = ({
    getMessage,
    className,
    ...restProps,
}) => (
    <div className={classNames("panel-body", className)} {...restProps}>
        {getMessage("noColumns")}
    </div>
);

EmptyMessage.propTypes = {
    className: PropTypes.string,
    getMessage: PropTypes.func.isRequired,
};

EmptyMessage.defaultProps = {
    className: undefined,
};



// WEBPACK FOOTER //
// ./src/app/UI/components/templates/EmptyMessage.jsx